enum BenchmarkingQhpStateStatusEnum {
  None = "none",
  QhpFed = "qhpFed",
  QhpState = "qhpState",
}

export { BenchmarkingQhpStateStatusEnum };